export default __webpack_public_path__ + "static/media/analyzeIcon.c8cb00ee.svg";